import React, { useState, useEffect} from "react";
import "./Hero.css";
import heroImg from "../assets/hero.jpg";
import mbali1 from "../assets/mbali1.jpg";
import kids1 from "../assets/kids1.jpg";
import metric1 from "../assets/metric1.jpg";
import family1 from "../assets/family1.jpg";

const Hero = () => {
  const images = [metric1, kids1, family1];
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2000); // change image every 3 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section id="hero" className="hero">
      {/* Background image changes dynamically */}
      <img
        className="hero-slide"
        src={images[currentIndex]}
        alt="hero slideshow"
      ></img>

      <div className="hero-overlay">
        <div className="hero-content-background">
            <div className="hero-content">
              <h1 className="hero-title">Fleur Designs Photography</h1>
              <p className="hero-subtitle">
              “Turning your simple moments into precious memories”
              </p>
              <a
                href="https://wa.me/27828179265?text=Hi%2C%20please%20tell%20me%20more%20about%20your%20services."
                target="-_blank"
                rel="noopener noreferrer"
                className="hero-button"
              >
                WhatsApp
              </a>
            </div>
        </div>    
      </div>
    </section>
  );
};

export default Hero;
